<div class="ion-padding">
  <ion-icon data-cy="printeModalCloseBtn" class="close-btn" color="eprintprimary" (click)="dismiss()" name="close-circle-outline"></ion-icon>
  <ion-item class="ion-no-padding ion-margin-top" lines="none">
    <ion-icon slot="start" name="print-outline"></ion-icon>
    <ion-label class="ion-text-wrap">{{location?.CustomerName?.CustomerName || customerName}}</ion-label>
  </ion-item>
  <ion-item class="ion-no-padding" lines="none">
    <ion-icon slot="start" name="navigate-outline"></ion-icon>
    <ion-label class="ion-text-wrap">{{location.Location}} </ion-label>
    <ion-icon slot="end" name="information-circle-outline"></ion-icon>
  </ion-item>
  <div class="ion-margin-top">
    <ion-button data-cy="printeModalSelectBtn" color="eprintprimary" expand="full" shape="round" (click)="select()">{{'SELECT' | translate}}</ion-button>
  </div>
</div>